import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';
import { EOfficeType } from '../../../packages/api-models/common/json_query';

export const selectOfficeTypes = createSelector(
  selectJsonQuery,
  jsonQuery => (getTermsValue('office_type')(jsonQuery) ?? []) as EOfficeType[],
);
